import { get, post } from "./request";
import { apiPrefix, filterObjWithValidValue } from './url';


// 用户解绑-列表
export const getWaitUnbindUserList = (params) => {
  const validParams = filterObjWithValidValue(params);
  // return post(apiPrefix.baseApi + "/autoChannelCheck/getLfCheck", validParams);
  return get(apiPrefix.baseApi + "/user/unbinding/list", validParams);
}

// 用户解绑-允许解绑
export const allowUnbindWaitUnbindUser = (params) => {
  const validParams = filterObjWithValidValue(params);
  return post(apiPrefix.baseApi + "/user/unbinding/allowUnBind", validParams);
}
// 用户解绑
export const unbindWaitUnbindUser = (params) => {
  const validParams = filterObjWithValidValue(params);
  return get(apiPrefix.userAccountApi + "/userAccount/customerUnbinding", validParams);
}